import React from 'react';
import FontAwesome from 'react-fontawesome';
import PropTypes from 'prop-types';
import { _RemoveFile } from "../../styles";
var FileEntry = function FileEntry(_ref) {
  var children = _ref.children,
    onRemove = _ref.onRemove;
  return /*#__PURE__*/React.createElement("li", null, children, /*#__PURE__*/React.createElement(_RemoveFile, {
    onClick: onRemove
  }, /*#__PURE__*/React.createElement(FontAwesome, {
    name: "times"
  })));
};
FileEntry.propTypes = {
  children: PropTypes.string.isRequired,
  onRemove: PropTypes.func.isRequired
};
export default FileEntry;